module.exports = __webpack_public_path__ + "media/images/flags/4x3/bra-46d9eb52cef525e9d85efd37a4464de9.svg";